/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const mobileOrderItemSizeSchema = z.object({
	id: z.uuid(),
	name: z.string(),
	alt_name: z.string().nullable(),
});
